import { Navigate } from 'react-router-dom'
import { useRole } from '@/hooks/use-role'

export function DashboardRedirect() {
  const { activeRole, freelancerProfileId, clientProfileId, isLoading } = useRole()

  // Wait for role to load before redirecting
  if (isLoading || activeRole === null) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[hsl(var(--color-4))]" />
      </div>
    )
  }

  // Safety check: ensure profile ID exists for the active role
  // If role is set but profile doesn't exist, redirect to onboarding
  if (activeRole === 'freelancer' && freelancerProfileId === null) {
    return <Navigate to="/onboarding" replace />
  }
  if (activeRole === 'client' && clientProfileId === null) {
    return <Navigate to="/onboarding" replace />
  }

  // Redirect based on active role
  switch (activeRole) {
    case 'freelancer':
      return <Navigate to="/genius/dashboard" replace />
    case 'client':
      return <Navigate to="/client/dashboard" replace />
    case 'admin':
      return <Navigate to="/admin" replace />
    default:
      // If no role after loading, go to onboarding
      return <Navigate to="/onboarding" replace />
  }
}
